var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-crop-container",staticStyle:{"margin":"10px"}},[_c('cropper',{staticClass:"cropper",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","width":"515px","height":"512px"},attrs:{"src":_vm.img,"canvas":{
      minHeight: 0,
      minWidth: 0,
      maxHeight: 256,
      maxWidth: 256,
    },"stencil-props":{
      aspectRatio: 1 / 1,
    },"default-size":{
      width: 400,
      height: 400,
    },"min-height":200,"min-width":200,"stencil-component":"circle-stencil"},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }